import { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import HelpState from "../../components/HelpCentre/HelpState";
import TopicGrid from "../../components/HelpCentre/TopicGrid";
import { useCanEditHelp } from "../../hooks/useHelpCentre";
import { HELP_CENTRE_PATH } from "../../utils/helpCentre/content";

const HelpCentreConfiguration = lazy(() => import("./HelpCentreConfiguration"));

/** Placeholder cards while the access check, or the editor's code, loads. */
function ConfigurationLoading() {
	return (
		<div className="help-body help-body--wide">
			<TopicGrid skeletonCount={8} />
		</div>
	);
}

/**
 * The configuration page's gate. The editor's code (its own chunk, with
 * drag-and-drop and its styles) loads only once the server says this user
 * may edit; the client asks in one place (`useCanEditHelp`), and the server
 * refuses anyone else's writes whatever the client does.
 */
function HelpCentreConfigurationRoute() {
	const { canEdit, isError, isFetching, refetch } = useCanEditHelp();

	if (canEdit === undefined) {
		return isError ? (
			<div className="help-body">
				<HelpState
					onRetry={() => refetch()}
					retrying={isFetching}
					message="We couldn't check whether you can configure the Help Centre."
				/>
			</div>
		) : (
			<ConfigurationLoading />
		);
	}

	if (!canEdit) {
		return (
			<div className="help-body">
				<div className="help-unavailable">
					<p>Only super admins can configure the Help Centre.</p>
					<Link to={HELP_CENTRE_PATH}>Back to the Help Centre</Link>
				</div>
			</div>
		);
	}

	return (
		<Suspense fallback={<ConfigurationLoading />}>
			<HelpCentreConfiguration />
		</Suspense>
	);
}

export default HelpCentreConfigurationRoute;
